import type { NavigationRoutingRegistryType } from "@navigationRouting/navigationRouting";

import type { FeatureName } from "@lib/featureFlipper";

/**
 * Returns the route path for the first deliverability tab the current
 * user has access to, or `null` if none are enabled.
 *
 * Used by:
 * - The base NRO's `getDeveloperNavigationAllowed` to control sidebar visibility.
 * - `DeliverabilityRedirect` to determine where to forward the user.
 *
 * When adding a new channel tab, add a check here in priority order.
 */
export const getFirstEnabledDeliverabilityRoute = (
  featureOn: (featureName: FeatureName) => boolean
): keyof NavigationRoutingRegistryType | null => {
  if (featureOn("enable_email_deliverability_dashboard")) {
    return "/dashboard/analytics_dashboard_deliverability/email/:appGroupId";
  }

  return null;
};
